import styled from "styled-components";

export const VideoSlidesUserMenuButtonDefaultBox = styled.div`
    position: relative;
    &:before {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      content: " ";
      height: 100%;
      position: absolute;
      top: 0;
      width: 10px;
      left: -10px;
    }
`;